<template>
  <div class="brand-select">

    <label v-if="label">{{ label }}</label>
     <div class="d-flex align-items-center">  
              <button
                  title = 'Reset'
                  class = "btn btn-light"
                  type  = "button"
                  @click="modelValue=[]"
                >
                  <i style="color:black" class='fas fa-sync'></i>
                </button>
    <v-select
      class="flex-fill"
      v-model="modelValue"
      :options=" availableBrands"
      :multiple="true"
     
      label="brand"
      :value="value"
      @input="updateValue"
      placeholder="Seleziona uno o più brand"
       :close-on-select="false"
      
      >


   
<template #search="{attributes, events}" >
    <input
      class="vs__search"
      :required="required && modelValue.length == 0"
      v-bind="attributes"
      v-on="events"
    />
</template>


    </v-select>
    </div>

    
  </div>
</template>

<script>
import { mapGetters }  from 'vuex';
import api             from '@/api'    

import vSelect         from "vue-select"
import "vue-select/dist/vue-select.css"

export default {
  name: "BrandSelect",

  components: { vSelect },
   data() {
    return {
    
      items                  : [],
      spinner                : false
     
    };
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },
   
    label: {
      type: String,
      default: "Brand"
    },
    required:{type:Boolean,default:false}
  },
  computed :{
    
      ...mapGetters(['company']),

       modelValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit("input", val)
        }
        },



        availableBrands() {
                  const hasAll = this.modelValue.includes("TUTTI I BRAND");
                  const hasOtherBrands =
                    this.modelValue.length > 0 && !hasAll;

                  // Caso 1 → Se è selezionato TUTTI I BRAND
                  if (hasAll) {
                    return this.items.filter(
                      item => item === "TUTTI I BRAND"
                    );
                  }

                  // Caso 2 → Se è selezionato almeno un brand normale
                  if (hasOtherBrands) {
                    return this.items.filter(
                      item =>
                        item !== "TUTTI I BRAND" &&
                        !this.modelValue.includes(item)
                    );
                  }

                  // Caso 3 → Nulla selezionato
                  return this.items;
}






  },
  created()
  {
    this.getData()
  },
  methods: {
    async getData()
    {
            
      const sp    = {'sp'         : 'spCompanyBrandList'}      
      const data  = {'companyId'  : this.company.Id}
      const json  = Object.assign(data, sp)
      
      

      await api.post(json).then(res => {
          
         
          if(res.status==200)
            {
              
              //this.items.push('TUTTI I BRAND')
              //this.items = res.data.recordsets[0]


              //return

              // Solo i brand nuovi
              
              /*
              this.items = [{brand :'TUTTI I BRAND'}]
              res.data.recordsets[0].forEach(item => {
                this.items.push({'brand':item.brand})
              });
              */
              this.items = ['TUTTI I BRAND']
                res.data.recordsets[0].forEach(item => {
                this.items.push(item.brand)
              });

            }
           else if(res.status==500)
           {
                console.log(res.data)
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });
    
 



     
    },
  
    
    
    updateValue(val) {
      this.$emit("input", val)
    }

  }
}
</script>

<style scoped>

label{
  font-weight: bold; 
}


:deep(.vs__dropdown-toggle) {
  border: 1px solid #ced4da !important;
  border-radius: 0.375rem !important;
  padding: 0.375rem 0.75rem !important;
}







</style>
